import { contains, equals, join } from 'ramda';
import { getLocale } from '../env/getLocale';
import { MediaProducer } from '../hoc/bi/withPurchaseAnalytics/withPurchaseAnalytics.types';
import { wixComDomain } from '../hoc/withMMGRSettings/defaultMMGRSettings';
import { TMMGRSettings } from '../hoc/withMMGRSettings/withMMGRSettings.types';
import { MediaManagerSDKFile } from '../media-manager-sdk';
import { isShutterstockItem, isVideoFile } from '../media-manager-sdk/items';
import { argsFromObject } from '../url';
import { CheckoutMediaType } from './types';

export const MEDIA_PURCHASE_ACTION = '__mediaPurchase';

export const buyItemNewCheckout = (
  item: MediaManagerSDKFile,
  mmgrSettings: TMMGRSettings,
  tab: string,
): Promise<{ item: MediaManagerSDKFile; isNew: boolean }> =>
  new Promise((resolve, reject) => {
    const checkoutMediaType = isVideoFile(item) ? CheckoutMediaType.Video : CheckoutMediaType.Image;
    const mediaProducer = isShutterstockItem(item) ? MediaProducer.ShutterStock : MediaProducer.WixStock;

    let checkoutBaseUrl = `${wixComDomain}/media-manager`;

    if (process.env.NODE_ENV === 'development') {
      checkoutBaseUrl = wixComDomain;
    }

    const urlBase = `${checkoutBaseUrl}/checkout`;
    const urlParams = argsFromObject({
      locale: getLocale(),
      siteToken: mmgrSettings.siteMediaToken,
      fileId: item.id,
      checkoutMediaType,
      mediaProducer,
      origin: mmgrSettings.origin,
      tab,
      source: mmgrSettings.openSource,
      publicMediaRoot: join(',', mmgrSettings.publicMediaRoot),
    });
    const url = `${urlBase}?${urlParams}`;

    window.open(url, '_blank', 'width=1150,height=900');

    const onWindowMessage = (event) => {
      if (!contains(location.hostname, event.origin)) {
        return;
      }

      let response;

      try {
        response = JSON.parse(event.data);
      } catch (ex) {
        return;
      }

      if (equals(response.action, MEDIA_PURCHASE_ACTION) && response.itemId === item.id) {
        window.removeEventListener('message', onWindowMessage, false);
        if (response.success) {
          resolve({ item, isNew: response.isNew });
        } else {
          reject({ item, isNew: response.isNew });
        }
      }
    };

    window.addEventListener('message', onWindowMessage, false);

    window.focus();
  });
